<!--
Copyright (C) 2016-2024 Stichting Palga
This file is distributed under the GNU Affero General Public License
(see accompanying file LICENSE).
-->
<div class="dntp-yell">
	{{ 'Faster! Easier! Safer!' | translate }}
</div>
